import theme from './theme';

export const alertStyle = {
    position: 'fixed',
    right: '50%',
    top: '15%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    height: '3px'
}
export const appLayout = {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
}
export const appLayoutWithFooter = {
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
};
export const mainComponentSx = {
    marginBottom: '40px',
};

export const displayFlex = {
    display: 'flex'
};
export const flexRow = {
    ...displayFlex,
    flexDirection: 'row',
};
export const flexSpaceBtw = {
    ...flexRow,
    justifyContent: 'space-between'
};